interface DistrictMapProps {
  districtName: string;
  talukCount: number;
  businessCount: number;
}

export default function DistrictMap({
  districtName,
  talukCount,
  businessCount,
}: DistrictMapProps) {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(
    `${districtName}, Karnataka, India`,
  )}&z=10&output=embed`;

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="flex flex-col gap-3 border-b border-background-200 bg-background-100 px-4 py-4 md:px-5 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <span className="flex h-5 w-5 items-center justify-center text-primary-600">
              <i className="ri-map-2-line text-lg" />
            </span>
            {districtName} on the map
          </h2>
          <p className="mt-1 text-xs text-foreground-600 md:text-sm">
            Zoom, pan and explore the district along with its taluks before you start browsing.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-community-line text-[13px]" />
            </span>
            {talukCount} taluks
          </span>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-store-3-line text-[13px]" />
            </span>
            {businessCount.toLocaleString("en-IN")} businesses
          </span>
        </div>
      </div>
      <div className="relative h-[300px] w-full md:h-[400px]">
        <iframe
          title={`Map of ${districtName}, Karnataka`}
          src={mapSrc}
          className="h-full w-full border-0"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}